import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-orange",
  "use": "icon-orange-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-orange\"><defs><style>#icon-orange .cls-1{fill:#ff812c;}</style></defs><title>orange</title><g id=\"icon-orange_图层_2\" data-name=\"图层 2\"><g id=\"icon-orange_图层_1-2\" data-name=\"图层 1\"><rect class=\"cls-1\" width=\"20\" height=\"20\" rx=\"2\" ry=\"2\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol